<template>
    <div name="basic-pc">
        <navigation />
        <banner />
        <introduction />
        <reason />
        <easy-service />
        <review />
        <instance />
        <partnerships />
        <barocare-story />
        <barocare-footer />
        <!-- <popup /> -->
    </div>
</template>

<script>
import Navigation from '@/components/pc_barocare/Navigation';
import Banner from '@/components/pc_barocare/Banner';
import Introduction from '@/components/pc_barocare/Introduction';
import Reason from '@/components/pc_barocare/Reason';
import EasyService from '@/components/pc_barocare/EasyService';
import Review  from '@/components/pc_barocare/Review';
import Instance  from '@/components/pc_barocare/Instance';
import Partnerships  from '@/components/pc_barocare/Partnerships';
import BarocareStory  from '@/components/pc_barocare/BarocareStory';
import BarocareFooter from '@/components/pc_barocare/BarocareFooter';
// import Popup from '@/components/pc_barocare/Popup';

export default {
    name: 'basicPc',
    components: {
        Navigation,
        Banner,
        Introduction,
        Reason,
        EasyService,
        Review,
        Instance,
        Partnerships,
        BarocareStory,
        BarocareFooter,
        // Popup
    },
    mounted: function(){
        $('html').animate({
            scrollTop: 0
        }, 300)
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/PcBarocare.vue